import { desktopHeaderHeight, mobileHeaderHeight } from 'hooks/useHeaderHeights';

import Basket from 'components/Basket';
import React from 'react';
import { above } from 'utils/mediaqueries';
import { basketProp } from 'utils/proptypes/basket';
import { injectModel } from 'state';
import styled from 'libs/styled';
import useClientHeight from 'hooks/useClientHeight';

const TransitionElement = styled('div', {
    shouldForwardProp: prop => ['clientHeight', 'hasProducts'].indexOf(prop) === -1,
})`
    position: absolute;
    top: ${mobileHeaderHeight}px;
    height: ${({ clientHeight, hasProducts }) =>
        hasProducts ? `calc(${clientHeight} - ${mobileHeaderHeight}px)` : 'auto'};
    width: 100vw;

    ${above.md} {
        position: fixed;
        right: 0;
        top: ${desktopHeaderHeight}px;
        width: 50vw;
        max-width: 960px;
        height: ${({ clientHeight, hasProducts }) =>
            hasProducts ? `calc(${clientHeight} - ${desktopHeaderHeight}px)` : 'auto'};

        &::after {
            display: none;
        }
    }
`;

const BasketOverlay = ({ basket }) => {
    const clientHeight = useClientHeight();

    return (
        <TransitionElement
            className="slide-in right"
            clientHeight={clientHeight}
            hasProducts={basket.items?.length > 0}
        >
            <Basket items={basket.items} />
        </TransitionElement>
    );
};

BasketOverlay.propTypes = {
    basket: basketProp.isRequired,
};

export default injectModel('basket')(BasketOverlay);
